import { render } from "./StoragePosition.vue?vue&type=template&id=517fa8ce"
import script from "./StoragePosition.vue?vue&type=script&lang=js"
export * from "./StoragePosition.vue?vue&type=script&lang=js"

import "./StoragePosition.vue?vue&type=style&index=0&id=517fa8ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__